module.exports = __webpack_public_path__ + "static/img/tougao.706cc0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tougao.jpg
// module id = hXRv
// module chunks = 1